import axios from 'axios'

export default {
  install (Vue) {
    Vue.prototype.$http = axios
    Vue.http = axios
  },
  $http: axios
}

export const $http = axios



// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/plugins/ajax/index.js